import { render, staticRenderFns } from "./ClientNotificationEditFormPopup.vue?vue&type=template&id=ba4a87fc&scoped=true&"
import script from "./ClientNotificationEditFormPopup.vue?vue&type=script&lang=js&"
export * from "./ClientNotificationEditFormPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4a87fc",
  null
  
)

export default component.exports